import request from '@/utils/request'

export function getClubInfo() {
  return request({
    url: '/api/admin/Clubs/info',
    method: 'GET'
  })
}
